import { Modal } from '@prosolve/common-components-ui';
import EventCard from './EventCard';

export default ({
  eventData,
  onClose
}) => {
  return (
    <Modal title={'Event'} isAutoHeight={true} onClose={onClose} closeOnOffClick={true}>
      <div style={{
        padding: '10px'
      }}>
      <EventCard eventData={eventData} />
      </div>
    </Modal>
  )
}